module.exports = __webpack_public_path__ + "img/news015.6d379094.jpg";